import { render } from "./ModalClientes.vue?vue&type=template&id=66c2f482&scoped=true"
import script from "./ModalClientes.vue?vue&type=script&lang=js"
export * from "./ModalClientes.vue?vue&type=script&lang=js"

import "./ModalClientes.vue?vue&type=style&index=0&id=66c2f482&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66c2f482"]])

export default __exports__